"use strict";
/* Copyright (c) 2022 Xperi. All Rights Reserved. */
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationStartup = void 0;
/* tslint:disable:no-console */
var EventQueue_1 = require("./eventqueue/EventQueue");
var LogLevels_1 = require("./loggers/LogLevels");
var Payload_1 = require("./sendables/Payload");
var AnalyticsConstants_1 = require("./AnalyticsConstants");
var ApplicationStartup = /** @class */ (function () {
    function ApplicationStartup() {
    }
    ApplicationStartup.getLogPrefix = function () {
        var d = new Date();
        var sDate = "".concat(d.getUTCDate()).padStart(2, '0');
        var sMonth = "".concat(d.getUTCMonth() + 1).padStart(2, '0');
        var sHour = "".concat(d.getUTCHours()).padStart(2, '0');
        var sMin = "".concat(d.getUTCMinutes()).padStart(2, '0');
        var sSec = "".concat(d.getUTCSeconds()).padStart(2, '0');
        var sMili = "".concat(d.getUTCMilliseconds()).padStart(3, '0');
        return "".concat(d.getFullYear(), "-").concat(sMonth, "-").concat(sDate, " ").concat(sHour, ":").concat(sMin, ":").concat(sSec, ".").concat(sMili);
    };
    ApplicationStartup.optionalParamsToString = function (optionalParams) {
        var msg = '';
        optionalParams.forEach(function (param) {
            msg += typeof param === 'object' ? JSON.stringify(param) : param;
            msg += ' ';
        });
        return msg.trim();
    };
    ApplicationStartup.addEventToQueue = function (eventType, tag, message) {
        var optionalParams = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            optionalParams[_i - 3] = arguments[_i];
        }
        var payloadMessage = "".concat(ApplicationStartup.getLogPrefix(), " [").concat(tag, "] ").concat(eventType, " ").concat(message, " ").concat(ApplicationStartup.optionalParamsToString(optionalParams));
        var payload = new Payload_1.Payload();
        payload.add(AnalyticsConstants_1.AnalyticsConstants.Fields.DEVICE_LOG_LEVEL, LogLevels_1.LogLevels[ApplicationStartup.logLevel]);
        payload.add(AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_NAME, tag);
        payload.add(AnalyticsConstants_1.AnalyticsConstants.Fields.LOG_TYPE, AnalyticsConstants_1.AnalyticsConstants.LogTypes.DIAGNOSTICS);
        payload.add(AnalyticsConstants_1.AnalyticsConstants.Fields.MESSAGE, payloadMessage);
        payload.add(AnalyticsConstants_1.AnalyticsConstants.Fields.REFRENCE_TIME, new Date().getTime());
        var finalPayload = payload.merge(ApplicationStartup.globals);
        ApplicationStartup.eventQueue.add(finalPayload);
        if (!ApplicationStartup.noConsoleLog) {
            console.log(ApplicationStartup.TAG, finalPayload.toSendable());
        }
    };
    ApplicationStartup.upload = function (transport) {
        if (ApplicationStartup.eventQueue.hasNext()) {
            transport
                .send(ApplicationStartup.eventQueue.next().merge(ApplicationStartup.globals))
                .then(function () {
                ApplicationStartup.eventQueue.remove();
            })
                .catch(function (err) {
                if (err) {
                    ApplicationStartup.eventQueue.remove();
                }
            })
                .finally(function () {
                ApplicationStartup.upload(transport);
            });
        }
    };
    ApplicationStartup.setGlobals = function (params) {
        ApplicationStartup.globals = params;
    };
    ApplicationStartup.debug = function (tag, message) {
        var optionalParams = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            optionalParams[_i - 2] = arguments[_i];
        }
        if (LogLevels_1.LogLevels.DEBUG <= ApplicationStartup.logLevel) {
            ApplicationStartup.addEventToQueue.apply(ApplicationStartup, __spreadArray([AnalyticsConstants_1.AnalyticsConstants.DiagnosticsEventTypes.DEBUG,
                tag,
                message], optionalParams, false));
        }
    };
    ApplicationStartup.error = function (tag, message) {
        var optionalParams = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            optionalParams[_i - 2] = arguments[_i];
        }
        if (LogLevels_1.LogLevels.ERROR <= ApplicationStartup.logLevel) {
            ApplicationStartup.addEventToQueue.apply(ApplicationStartup, __spreadArray([AnalyticsConstants_1.AnalyticsConstants.DiagnosticsEventTypes.ERROR,
                tag,
                message], optionalParams, false));
        }
    };
    ApplicationStartup.info = function (tag, message) {
        var optionalParams = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            optionalParams[_i - 2] = arguments[_i];
        }
        if (LogLevels_1.LogLevels.INFO <= ApplicationStartup.logLevel) {
            ApplicationStartup.addEventToQueue.apply(ApplicationStartup, __spreadArray([AnalyticsConstants_1.AnalyticsConstants.DiagnosticsEventTypes.INFO,
                tag,
                message], optionalParams, false));
        }
    };
    ApplicationStartup.warn = function (tag, message) {
        var optionalParams = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            optionalParams[_i - 2] = arguments[_i];
        }
        if (LogLevels_1.LogLevels.WARN <= ApplicationStartup.logLevel) {
            ApplicationStartup.addEventToQueue.apply(ApplicationStartup, __spreadArray([AnalyticsConstants_1.AnalyticsConstants.DiagnosticsEventTypes.WARN,
                tag,
                message], optionalParams, false));
        }
    };
    ApplicationStartup.setLogLevel = function (level) {
        ApplicationStartup.logLevel = level;
    };
    ApplicationStartup.noConsole = function () {
        ApplicationStartup.noConsoleLog = true;
    };
    ApplicationStartup.TAG = 'ApplicationStartup';
    ApplicationStartup.eventQueue = new EventQueue_1.EventQueue();
    ApplicationStartup.logLevel = LogLevels_1.LogLevels.INFO;
    ApplicationStartup.noConsoleLog = false;
    (function () {
        ApplicationStartup.eventQueue.setSize(1101);
    })();
    return ApplicationStartup;
}());
exports.ApplicationStartup = ApplicationStartup;
